var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseCancelGray = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9443 4.34184L4.87813 14.4787C4.65487 14.702 4.50284 14.9782 4.45548 15.2465C4.40812 15.5149 4.46931 15.7535 4.62559 15.9098C4.78187 16.066 5.02044 16.1272 5.28881 16.0799C5.55718 16.0325 5.83338 15.8805 6.05664 15.6572L16.1228 5.52035C16.3461 5.29709 16.4981 5.0209 16.5455 4.75252C16.5928 4.48415 16.5316 4.24558 16.3753 4.0893C16.2191 3.93302 15.9805 3.87183 15.7121 3.91919C15.4437 3.96655 15.1676 4.11858 14.9443 4.34184Z",
    fill: "#78829D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1582 14.4433L6.02128 4.37715C5.79802 4.15389 5.52183 4.00186 5.25345 3.9545C4.98508 3.90714 4.74651 3.96833 4.59023 4.12461C4.43395 4.28089 4.37276 4.51946 4.42012 4.78783C4.46748 5.05621 4.61951 5.3324 4.84277 5.55566L14.9797 15.6218C15.2029 15.8451 15.4791 15.9971 15.7475 16.0445C16.0159 16.0918 16.2544 16.0306 16.4107 15.8744C16.567 15.7181 16.6282 15.4795 16.5808 15.2111C16.5335 14.9428 16.3814 14.6666 16.1582 14.4433Z",
    fill: "#78829D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseCancelGray);
export default ForwardRef;